(function ($) {
    if ($('body').hasClass('page-template-template-naujienos')) {
        //
        // Polyfill for object.assign, needed for lozad plugin to work on IE11
        //
        // window.ObjectAssign.polyfill();

        var url = new URL(window.location);
        var urlParams = (new URL(document.location)).searchParams;

        $('.news-filter .category-selection').on('click', function () {
            var params = [];
            var inputs = $('.category-selection');

            $(this).toggleClass('active');
            $('.date-selection').addClass('disabled');
            $('.category-selection').addClass('disabled');

            if ($(this).hasClass('active')) {
                $(inputs).each(function (index, el) {
                    if ($(el).hasClass('active')) {
                        params.push($(el).attr('data-category'));
                    }
                });
                updateUrlParams('category', params.join(','));
            } else {
                updateUrlParams('category');
                $(inputs).each(function (index, el) {
                    if ($(el).hasClass('active')) {
                        params.push($(el).attr('data-category'));
                    }
                });
                updateUrlParams('category', params.join(','));
            }
            $('.news-columns').attr('data-page', '1');
            updateUrlParams('pages');

            getNews();
        });

        $('.news-filter .date-selection').on('click', function () {
            $(this).addClass('active');
            $('.date-selection').addClass('disabled');
            $('.category-selection').addClass('disabled');
            $(this).siblings().removeClass('active');

            if ($(this).hasClass('active')) {
                var value = $(this).attr('data-year');
                updateUrlParams('years', value);
            } else {
                updateUrlParams('years');
            }

            $('.news-columns').attr('data-page', '1');
            updateUrlParams('pages');

            getNews();
        });

        function checkPagination(max = 0) {
            var currentPage = $('.news-columns').attr('data-page');
            $('.pagination').removeClass('active');
            if (max > 1) {
                $('.pagination').addClass('active');
            }
            if ($('.news-columns').attr('data-page') <= 1) {
                $('.pagination .pag-prev').addClass('disabled');
            } else {
                $('.pagination .pag-prev').removeClass('disabled');
            }
            if ($('.news-columns').attr('data-page') >= max) {
                $('.pagination .pag-next').addClass('disabled');
            } else {
                $('.pagination .pag-next').removeClass('disabled');
            }

            $('.pagination-numbers').empty();

            if (parseInt(currentPage) - 1 > 2) {
                $('.pagination-numbers').append('<span class="page-number" data-page="' + 1 + '">' + 1 + '</span>');
                $('.pagination-numbers').append('<span class="page-number dots">...</span>');
            } else if (parseInt(currentPage) - 1 > 1) {
                $('.pagination-numbers').append('<span class="page-number" data-page="' + 1 + '">' + 1 + '</span>');
            }

            for (var prevPage = parseInt(currentPage) - 2; prevPage < parseInt(currentPage); prevPage++) {
                if (prevPage > 0 && prevPage > parseInt(currentPage) - 2) {
                    $('.pagination-numbers').append('<span class="page-number" data-page="' + prevPage + '">' + prevPage + '</span>');
                }
            }

            $('.pagination-numbers').append('<span class="page-number current" data-page="' + currentPage + '">' + currentPage + '</span>');

            for (var nextPage = parseInt(currentPage) + 1; nextPage < parseInt(currentPage) + 2; nextPage++) {
                if (nextPage <= max) {
                    $('.pagination-numbers').append('<span class="page-number" data-page="' + nextPage + '">' + nextPage + '</span>');
                }
            }

            if (max > 2 && parseInt(currentPage) + 1 < max - 1) {
                $('.pagination-numbers').append('<span class="page-number dots">...</span>');
                $('.pagination-numbers').append('<span class="page-number" data-page="' + max + '">' + max + '</span>');
            } else if (max > 2 && parseInt(currentPage) + 1 < max) {
                $('.pagination-numbers').append('<span class="page-number" data-page="' + max + '">' + max + '</span>');
            }
        }

        $(document).on("click", ".page-number", function () {
            $(this).addClass('current');
            $('.date-selection').addClass('disabled');
            $('.category-selection').addClass('disabled');
            $(this).siblings().removeClass('current');

            var value = $(this).attr('data-page');
            updateUrlParams('pages', value);

            $('.news-columns').attr('data-page', $(this).attr('data-page'));

            getNews();
        });

        $('.pag-next').on('click', function () {
            var current = $('.news-columns').attr('data-page');

            $('.date-selection').addClass('disabled');
            $('.category-selection').addClass('disabled');

            $('.news-columns').attr('data-page', parseInt(current) + 1);

            updateUrlParams('pages', $('.news-columns').attr('data-page'));

            getNews();
        });

        $('.pag-prev').on('click', function () {
            var current = $('.news-columns').attr('data-page');

            $('.date-selection').addClass('disabled');
            $('.category-selection').addClass('disabled');

            $('.news-columns').attr('data-page', parseInt(current) - 1);

            updateUrlParams('pages', $('.news-columns').attr('data-page'));

            getNews();
        });

        function getNews() {
            var urlParams = new URLSearchParams(location.search);
            $('html, body').animate({scrollTop: $('#news').offset().top}, 1000);
            var data = {
                'action': 'load_news',
                'pages': $('.news-columns').attr('data-page'),
                'category': urlParams.get('category'),
                'years': urlParams.get('years')
            };

            $('.news-columns').addClass('loading');
            $('.news-cards').empty();
            checkPagination();

            setTimeout(function () {
                $.get(postmpwp.ajax_url, data, function (response) {
                    console.log(response);
                    if (response.success) {
                        $('.news-columns').removeClass('loading');
                        $('.news-cards').append(response.data.news);
                        $('.news-columns').attr('data-max-page', response.data.max_num);
                        checkPagination(response.data.max_num);
                        $('.date-selection').removeClass('disabled');
                        $('.category-selection').removeClass('disabled');
                        $('.no-results').removeClass('active');
                    } else {
                        $('.news-columns').removeClass('loading');
                        $('.date-selection').removeClass('disabled');
                        $('.category-selection').removeClass('disabled');
                        $('.no-results').addClass('active');
                    }
                });
            }, 600);
        }

        function updateUrlParams(param, value) {
            if (value) {
                urlParams.set(param, value);

            } else {
                urlParams.delete(param);
            }

            url.search = urlParams.toString();

            history.replaceState({}, null, url.toString());
        }

        $(window).on('load', function () {
            getNews();
        })
    }
})(jQuery);